<template>
  <div v-if="permissionCheck('Employees','Read')" class="container-fluid">
    <div class="row actions no-print">
      <div class="col-md-3 float-left">
        Home >  Attendance > Search
      </div>
      <div class="col-md-9">
        <button v-if="selectedEmployee.name" style="float: right; margin-left: 5px;" class="btn btn-danger" @click="closeEmployee()"><icon name="search"></icon> Close</button>
        <button v-if="!searchFilters.isActive" style="float: right; margin-left: 5px;" class="btn btn-primary" @click="$refs.searchFilter.show()"><icon name="search"></icon> Search Filter</button>
        <button v-if="searchFilters.isActive" style="float: right;" class="btn btn-secondary" @click="$refs.searchFilter.show()"><icon name="search"></icon> Modify Filter</button>
        <button v-if="searchFilters.isActive" class="btn btn-success float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('attendance')"><icon name="calendar"></icon> Attendance</button>
        <button v-if="searchFilters.isActive" class="btn btn-warning float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('missed')"><icon name="times"></icon> Missed Punches</button>
        <button v-if="searchFilters.isActive" class="btn btn-danger float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('absent')"><icon name="warning"></icon> Absent</button>
      </div>
    </div>

    <div class="row">

      <div class="col content" v-show="!selectedEmployee.name  || searchFilters.resultsView != 'attendance'">

        <!------------------------------>
        <!--Search Filter Critera List-->
        <!------------------------------>
        <div class="row" style="background-color: rgba(0,0,0,0.03); padding: 5px;" v-if="searchFilters.isActive">
          <div class="col-md-12 no-print" style="background-color: rgba(0,0,0,0.06); text-align: center; font-size: 18px; padding: 10px; border: 1px solid rgba(0,0,0,0.2);">
            SEARCH CRITERIA
            <br/>
          </div>

          <div class="col-md-6" v-if="searchFilters.dateFrom">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Date From</strong></div>
              <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <b-badge variant="danger">{{searchFilters.dateFrom}}</b-badge>&nbsp;
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.dateTo">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Date To</strong></div>
              <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <b-badge variant="danger">{{searchFilters.dateTo}}</b-badge>&nbsp;
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.companies.length > 0">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Cost Company</strong></div>
              <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.companies"><b-badge variant="info">{{findCompany(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.sponsorCompanies.length > 0">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Sponsor Company</strong></div>
              <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.sponsorCompanies"><b-badge variant="info">{{findSponsorCompany(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.branches.length > 0">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Branches</strong></div>
              <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.branches"><b-badge variant="info">{{findBranch(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.departments.length > 0">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Departments</strong></div>
              <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.departments"><b-badge variant="info">{{findDepartment(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.designations.length > 0">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Designations</strong></div>
              <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.designations"><b-badge variant="info">{{findDesignation(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.religions.length > 0">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Religions</strong></div>
              <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.religions"><b-badge variant="info">{{findReligion(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.nationalities.length > 0">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Nationalities</strong></div>
              <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.nationalities"><b-badge variant="info">{{findNationality(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.cities.length > 0">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Cities</strong></div>
              <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.cities"><b-badge variant="info">{{data}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.employees.length > 0">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Employees</strong></div>
              <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.employees"><b-badge variant="info">{{findUser(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.shiftPlans.length > 0">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Shift Plans</strong></div>
              <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="data in searchFilters.shiftPlans"><b-badge variant="info">{{findShiftPlan(data).name}}</b-badge>&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="searchFilters.status.length > 0">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>User Status</strong></div>
              <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="statusx in searchFilters.status" ><span v-html="status(statusx)"></span> &nbsp;</span>
              </div>
            </div>
          </div>

<!--          <div class="col-md-12 no-print" style="padding: 10px;">-->
<!--            <button style="float: right;" class="btn btn-secondary" @click="$refs.searchFilter.show()"><icon name="search"></icon> Modify Filter</button>-->
<!--            <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('attendance')"><icon name="calendar"></icon> Attendance</button>-->
<!--            <button class="btn btn-warning float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('missed')"><icon name="times"></icon> Missed Punches</button>-->
<!--            <button class="btn btn-danger float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('absent')"><icon name="warning"></icon> Absent</button>-->
<!--          </div>-->
        </div>

        <div v-if="timesheetsList.length == 0">
          <div class="col-md-12">
            <h2 align="center"><br/><icon name="calendar" scale="2"></icon> TIMESHEET SUMMARY</h2>
          </div>
          <p align="center">Currently there are no results for the requested search criteria</p>
          <p align="center">Please use the search filter to find the records. </p>
        </div>

        <!------------------------------------------------->
        <!---- --Timsheets Attendance Summary Table-------->
        <!------------------------------------------------->

        <div v-if="timesheetsList.length > 0 && searchFilters.resultsView == 'attendance'" class="row" style="width: 101%;">

          <div v-show="timesheetsListLoading" class="col-md-12">
            <div class="row justify-content-md-center" style="width:100%;"><semipolar-spinner :animation-duration="2500" :size="200" :color="'#62a622'" ></semipolar-spinner></div>
            <div class="row justify-content-md-center" style="width:100%; font-size: 12px;">Please Wait..</div>
          </div>

          <!--Tickets List Table-->
          <div class="listxxx" style="overflow-y: auto; height: 62vh;  overflow-x: auto;  border-top: solid 1px #e7e7e7;">
            <div class="">
              <div class="">
                <table v-show="!timesheetsListLoading"  class="table table-hover" style="position: relative; margin-top: 10px;">
                  <thead>
                  <th class="" scope="col" style="z-index: 3; position: sticky; top: 0px; left:0; font-size: 12px; background-color: #fffaf0; min-width: 50px; height: 63px; padding-top: 20px;"><span @click="sortToggle('id')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('id')"></icon></span> ID </th>
                  <th class="" scope="col" style="z-index: 3; position: sticky; top: 0px; left: 50px; font-size: 12px; min-width: 175px; background-color: #fffaf0; height: 63px; padding-top: 20px;"><span @click="sortToggle('name')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('name')"></icon></span> Name</th>
                  <th scope="col" style="z-index: 2; position: sticky; top: 0px; font-size: 12px; min-width: 140px; background-color: #fffaf0;"><span @click="sortToggle('company')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('company')"></icon></span> Cost Company</th>
                  <th scope="col" style="z-index: 2; position: sticky; top: 0px; font-size: 12px; min-width: 140px; background-color: #fffaf0;"><span @click="sortToggle('sponsorCompany')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('sponsorCompany')"></icon></span> Sponsor Company</th>
                  <th scope="col" style="z-index: 2; position: sticky; top: 0px; font-size: 12px; background-color: #fffaf0;">Missed Punches</th>
                  <th scope="col" style="z-index: 2; position: sticky; top: 0px; font-size: 12px; background-color: #fffaf0;">Absences</th>
                  <th scope="col" style="z-index: 2; position: sticky; top: 0px; font-size: 12px; background-color: #fffaf0;">Leaves</th>
                  <th scope="col" style="z-index: 2; position: sticky; top: 0px; font-size: 12px; background-color: #fffaf0;">Missing</th>
                  <th scope="col" style="z-index: 2; position: sticky; top: 0px; font-size: 12px; background-color: #fffaf0;">Overtime</th>
                  <th scope="col" style="z-index: 2; position: sticky; top: 0px; font-size: 12px; background-color: #fffaf0; min-width: 80px;">Net Hours</th>
                  <th class="no-print" v-for="datex in dateRange" scope="col" style="position: sticky; top: 0px; min-width: 75px; font-size: 12px; background-color: #fffaf0;">
                    {{$moment(datex).format('ddd')}} <br/> {{$moment(datex).format('MMM D')}}
                  </th>
                  </thead>

                  <tbody>
                  <tr v-for="employee in timesheetsList">
                    <td class="" style="z-index: 1; position: sticky; left: 0; background-color: #eaf6ff; font-size: 12px; cursor: pointer;">{{employee.id}}</td>
                    <td class="" style="z-index: 1; position: sticky; left: 50px; background-color: #eaf6ff; font-size: 12px; cursor: pointer;" @click="selectEmployee(employee)"><span style="">{{employee.name}}</span> </td>
                    <td style="z-index: 1; font-size: 12px; cursor: pointer;">{{employee.company}}</td>
                    <td style="z-index: 1; font-size: 12px; cursor: pointer;">{{employee.sponsorCompany}}</td>
                    <td style="z-index: 1; font-size: 12px; cursor: pointer; background-color: #ffedf2;">{{missedPunchesx(employee)}}</td>
                    <td style="z-index: 1; font-size: 12px; cursor: pointer; background-color: #ffbdbe;">{{employee.absences}}</td>
                    <td style="z-index: 1; font-size: 12px; cursor: pointer; background-color: #d1d7ff;">{{employee.leaves}}</td>
                    <td style="z-index: 1; font-size: 12px; cursor: pointer; background-color: #ffce9a;">{{converter((employee.missingFinal/60).toFixed(2))}}</td>
                    <td style="z-index: 1; font-size: 12px; cursor: pointer; background-color: #d9ffda;">{{converter((employee.overtimeFinal/60).toFixed(2))}}</td>
                    <td style="z-index: 1; font-size: 12px; cursor: pointer; background-color: #cfd3ff;">{{converter(employee.totalHours)}}</td>
                    <td class="no-print" v-for="datex in dateRange" scope="col" style="z-index: 1; font-size: 12px; background-color: rgba(255,250,240,0.48);">
                                <span v-if="findTimesheet(employee.id, $moment(datex).format('YYYY-MM-DD'), employee.attendances)">
                                    <span v-for="timesheet in findTimesheet(employee.id, $moment(datex).format('YYYY-MM-DD'), employee.attendances)"  :style="[(timesheet.diff == 1) ? {'background-color': '#FFB0B2'} : {}]">
                                        <span v-if="timesheet">
                                            <span v-if="timesheet.status"><span v-html="attendanceBadge(timesheet.status, 1)"></span>
                                                <span v-if="timesheet.lID" class='badge badge-primary'>{{findLeaveType(timesheet.lID.leaveType).name}}</span>
                                                <span v-if="timesheet.status == 6" class='badge badge-warning'>{{findHoliday(timesheet.date).name}}</span>
                                            </span>
                                            <span v-if="timesheet.pIn" style="width: 220px;"><span :style="[timesheet.pIn.psID == 2 ? {'color': 'orange'} : {}]">{{$moment(timesheet.pIn.stamp).format("hh:mm A")}} </span> </span>
                                            <span v-if="timesheet.pInM == 1 && timesheet.status != 3 && timesheet.status != 2 && timesheet.status != 6"><b-badge variant="warning">M.P.</b-badge></span>
                                            <span v-if="timesheet.bStart"><span :style="[timesheet.bStart.psID == 2 ? {'color': 'orange'} : {}]">{{$moment(timesheet.bStart.stamp).format("hh:mm A")}}</span></span>
                                            <span v-if="timesheet.bStartM == 1 && timesheet.status != 3 && timesheet.status != 2 && timesheet.status != 6"><b-badge variant="warning">M.P.</b-badge></span>
                                            <span v-if="timesheet.bEnd"><span :style="[timesheet.bEnd.psID == 2 ? {'color': 'orange'} : {}]">{{$moment(timesheet.bEnd.stamp).format("hh:mm A")}}</span></span>
                                            <span v-if="timesheet.bEndM == 1 && timesheet.status != 3 && timesheet.status != 2 && timesheet.status != 6"><b-badge variant="warning">M.P.</b-badge></span>

                                            <span v-if="timesheet.pOut4"><span :style="[timesheet.pOut4.psID == 2 ? {'color': 'orange'} : {}]">{{$moment(timesheet.pOut4.stamp).format("hh:mm A")}} </span></span>
                                            <span v-else-if="timesheet.pOut3"><span :style="[timesheet.pOut3.psID == 2 ? {'color': 'orange'} : {}]">{{$moment(timesheet.pOut3.stamp).format("hh:mm A")}} </span></span>
                                            <span v-else-if="timesheet.pOut2"><span :style="[timesheet.pOut2.psID == 2 ? {'color': 'orange'} : {}]">{{$moment(timesheet.pOut2.stamp).format("hh:mm A")}} </span></span>
                                            <span v-else-if="timesheet.pOut"><span :style="[timesheet.pOut.psID == 2 ? {'color': 'orange'} : {}]">{{$moment(timesheet.pOut.stamp).format("hh:mm A")}} </span></span>
                                            <span v-if="timesheet.pOutM == 1 && timesheet.status != 3 && timesheet.status != 2 && timesheet.status != 6"><b-badge variant="warning">M.P.</b-badge>&nbsp;</span>
                                        </span>
                                    </span>
                                </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
          <!--Pagination Links-->
          <div class="col-md-12 standout" v-if="timesheetsList.length > 0" v-show="!timesheetsListLoading"  >
            <div class="row">
              <div class="col text-left" style="padding-top: 8px; font-size: 12px;">Total: {{timesheetsPaginationObject.totalRecords}} Employees</div>
              <div class="col text-center" style="min-width: 200px; font-size: 12px;">
                <button @click="updateRecordsList(1)" :disabled="!timesheetsPaginationObject.firstActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"><icon name="angle-double-left"></icon></button>
                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage-1)" :disabled="!timesheetsPaginationObject.previousActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-left"></icon> </button>
                &nbsp; {{timesheetsPaginationObject.currentPage}} of {{timesheetsPaginationObject.totalPages}} &nbsp;
                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage+1)" :disabled="!timesheetsPaginationObject.nextActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-right"></icon> </button>
                <button @click="updateRecordsList(timesheetsPaginationObject.totalPages)" :disabled="!timesheetsPaginationObject.lastActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-double-right"></icon> </button>
              </div>
              <div class="col text-right" style="float:right;">
                <select v-model="sorting.limit" class="form-control" style="max-width: 140px; float: right;">
                  <option :value="5">5 Per Page</option>
                  <option :value="10">10 Per Page</option>
                  <option :value="20">20 Per Page</option>
                  <option :value="30">30 Per Page</option>
                  <option :value="40">40 Per Page</option>
                  <option :value="50">50 Per Page</option>
                </select>
                <button class="btn btn-success float-right" type="submit" style="margin-right: 5px; margin-top: 5px;" @click="exportCSV('attendanceCSV')"><icon name="file"></icon> Export</button>

              </div>
            </div>
          </div>

        </div>


        <!------------------------------------------------->
        <!----------Absent Reports Summary Table----------->
        <!------------------------------------------------->

        <div v-if="timesheetsList.length > 0 && searchFilters.resultsView == 'absent'" class="row">
          <div class="col-md-12">
            <h2 align="center"><br/><icon name="calendar" scale="2"></icon> ABSENT SUMMARY</h2>
          </div>
          <div v-show="timesheetsListLoading" class="col-md-12">
            <div class="row justify-content-md-center" style="width:100%;"><semipolar-spinner :animation-duration="2500" :size="200" :color="'#62a622'" ></semipolar-spinner></div>
            <div class="row justify-content-md-center" style="width:100%; font-size: 12px;">Please Wait..</div>
          </div>

          <!--Tickets List Table-->
          <table v-show="!timesheetsListLoading"  class="table table-hover" style="margin-top: 10px;">
            <thead>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">ID</th>
            <th scope="col" style="font-size: 12px; min-width: 175px; background-color: #fffaf0;">Name</th>
            <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">Cost Company</th>
            <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">Sponsor Company</th>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Date</th>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Status</th>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Action</th>
            </thead>

            <tbody>

            <tr v-for="attendance in timesheetsList">
              <td style="font-size: 12px; cursor: pointer;">{{attendance.uID}}</td>
              <td style="font-size: 12px; cursor: pointer;">{{findUser(attendance.uID).name}}</td>
              <td style="font-size: 12px; cursor: pointer;" v-if="findCompany(attendance.uCC)">{{findCompany(attendance.uCC).name}}</td>
              <td style="font-size: 12px; cursor: pointer;" v-if="findSponsorCompany(attendance.uSC)">{{findSponsorCompany(attendance.uSC).name}}</td>
              <td style="font-size: 12px; cursor: pointer;">{{$moment(attendance.date).format('ddd DD-MM-YYYY')}}</td>
              <td style="font-size: 12px; cursor: pointer;"><span v-html="attendanceBadge(attendance.status)"></span></td>
              <td style="font-size: 12px; cursor: pointer;">
                <button v-if="permissionCheck('Leaves','Create')" class="btn btn-sm btn-primary float-right" type="submit" style="margin-right: 5px;" @click="updateLeave(attendance, attendance.uID, attendance.date)"><icon name="calendar"></icon> Leave</button>
                <button v-if="permissionCheck('Punches','Create')" class="btn btn-sm btn-warning float-right" type="submit" style="margin-right: 5px;" @click="updatePunches(attendance, attendance.uID)"><icon name="calendar"></icon> +Punches</button>
              </td>
            </tr>
            </tbody>
          </table>

          <!--Pagination Links-->
          <div class="col-md-12 standout" v-if="timesheetsList.length > 0" v-show="!timesheetsListLoading"  >
            <div class="row">
              <div class="col text-left" style="padding-top: 8px; font-size: 12px;">Total: {{timesheetsPaginationObject.totalRecords}} Absent Records</div>
              <div class="col text-center" style="min-width: 200px; font-size: 12px;">
                <button @click="updateRecordsList(1)" :disabled="!timesheetsPaginationObject.firstActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"><icon name="angle-double-left"></icon></button>
                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage-1)" :disabled="!timesheetsPaginationObject.previousActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-left"></icon> </button>
                &nbsp; {{timesheetsPaginationObject.currentPage}} of {{timesheetsPaginationObject.totalPages}} &nbsp;
                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage+1)" :disabled="!timesheetsPaginationObject.nextActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-right"></icon> </button>
                <button @click="updateRecordsList(timesheetsPaginationObject.totalPages)" :disabled="!timesheetsPaginationObject.lastActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-double-right"></icon> </button>
              </div>
              <div class="col text-right" style="float:right;">
                <select v-model="sorting.limit" class="form-control" style="max-width: 140px; float: right;">
                  <option :value="10">10 Per Page</option>
                  <option :value="20">20 Per Page</option>
                  <option :value="30">30 Per Page</option>
                  <option :value="40">40 Per Page</option>
                  <option :value="50">50 Per Page</option>
                </select>
                <button class="btn btn-success float-right" type="submit" style="margin-right: 5px; margin-top: 5px;" @click="exportCSV('absentCSV')"><icon name="file"></icon> Export</button>
              </div>
            </div>
          </div>

        </div>

        <!------------------------------------------------->
        <!----------Missing Punch Summary Table ----------->
        <!------------------------------------------------->

        <div v-if="timesheetsList.length > 0 && searchFilters.resultsView == 'missed'" class="row">
          <div class="col-md-12">
            <h2 align="center"><br/><icon name="calendar" scale="2"></icon> MISSED PUNCHES SUMMARY</h2>
          </div>
          <div v-show="timesheetsListLoading" class="col-md-12">
            <div class="row justify-content-md-center" style="width:100%;"><semipolar-spinner :animation-duration="2500" :size="200" :color="'#62a622'" ></semipolar-spinner></div>
            <div class="row justify-content-md-center" style="width:100%; font-size: 12px;">Please Wait..</div>
          </div>

          <!--Tickets List Table-->
          <table v-show="!timesheetsListLoading"  class="table table-hover" style="margin-top: 10px;">
            <thead>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">ID</th>
            <th scope="col" style="font-size: 12px; min-width: 175px; background-color: #fffaf0;">Name</th>
            <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">Cost Company</th>
            <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">Sponsor Company</th>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Date</th>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Check In</th>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Break Start</th>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Break End</th>
            <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Checkout</th>
            </thead>

            <tbody>

            <tr v-for="attendance in timesheetsList">
              <td style="font-size: 12px; cursor: pointer;">{{attendance.uID}}</td>
              <td style="font-size: 12px; cursor: pointer;">{{findUser(attendance.uID).name}}</td>
              <td style="font-size: 12px; cursor: pointer;" v-if="findCompany(attendance.uCC)">{{findCompany(attendance.uCC).name}}</td>
              <td style="font-size: 12px; cursor: pointer;" v-if="findSponsorCompany(attendance.uSC)">{{findSponsorCompany(attendance.uSC).name}}</td>
              <td style="font-size: 12px; cursor: pointer;">{{$moment(attendance.date).format('ddd DD-MM-YYYY')}}</td>
              <td style="font-size: 12px; cursor: pointer;">
                <span v-if="attendance.pIn">{{$moment(attendance.pIn.stamp).format("hh:mm A")}}</span>
                <button v-if="(attendance.pInM && permissionCheck('Punches','Create')) || (attendance.pInM && permissionCheck('Punches','Update'))" class="btn btn-sm btn-warning" type="submit" @click="updatePunches(attendance, attendance.uID, attendance.date)"><icon name="calendar"></icon> +Punches</button>
              </td>
              <td style="font-size: 12px; cursor: pointer;">
                <span v-if="attendance.bStart">{{$moment(attendance.bStart.stamp).format("hh:mm A")}}</span>
                <button v-if="(attendance.bStartM && permissionCheck('Punches','Create')) || (attendance.bStartM && permissionCheck('Punches','Update'))" class="btn btn-sm btn-warning" type="submit" @click="updatePunches(attendance, attendance.uID, attendance.date)"><icon name="calendar"></icon> +Punches</button>
              </td>
              <td style="font-size: 12px; cursor: pointer;">
                <span v-if="attendance.bEnd">{{$moment(attendance.bEnd.stamp).format("hh:mm A")}}</span>
                <button v-if="(attendance.bEndM && permissionCheck('Punches','Create')) || (attendance.bEndM && permissionCheck('Punches','Update'))" class="btn btn-sm btn-warning" type="submit" @click="updatePunches(attendance, attendance.uID, attendance.date)"><icon name="calendar"></icon> +Punches</button>
              </td>
              <td style="font-size: 12px; cursor: pointer;">
                <span v-if="attendance.pOut">{{$moment(attendance.pOut.stamp).format("hh:mm A")}}</span>
                <button v-if="(attendance.pOutM && permissionCheck('Punches','Create')) || (attendance.pOutM && permissionCheck('Punches','Update'))" class="btn btn-sm btn-warning" type="submit" @click="updatePunches(attendance, attendance.uID, attendance.date)"><icon name="calendar"></icon> +Punches</button>
              </td>
            </tr>
            </tbody>
          </table>

          <!--Pagination Links-->
          <div class="col-md-12 standout" v-if="timesheetsList.length > 0" v-show="!timesheetsListLoading"  >
            <div class="row">
              <div class="col text-left" style="padding-top: 8px; font-size: 12px;">Total: {{timesheetsPaginationObject.totalRecords}} Absent Records</div>
              <div class="col text-center" style="min-width: 200px; font-size: 12px;">
                <button @click="updateRecordsList(1)" :disabled="!timesheetsPaginationObject.firstActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"><icon name="angle-double-left"></icon></button>
                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage-1)" :disabled="!timesheetsPaginationObject.previousActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-left"></icon> </button>
                &nbsp; {{timesheetsPaginationObject.currentPage}} of {{timesheetsPaginationObject.totalPages}} &nbsp;
                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage+1)" :disabled="!timesheetsPaginationObject.nextActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-right"></icon> </button>
                <button @click="updateRecordsList(timesheetsPaginationObject.totalPages)" :disabled="!timesheetsPaginationObject.lastActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-double-right"></icon> </button>
              </div>
              <div class="col text-right" style="float:right;">
                <select v-model="sorting.limit" class="form-control" style="max-width: 140px; float: right;">
                  <option :value="10">10 Per Page</option>
                  <option :value="20">20 Per Page</option>
                  <option :value="30">30 Per Page</option>
                  <option :value="40">40 Per Page</option>
                  <option :value="50">50 Per Page</option>
                </select>
                <button class="btn btn-success float-right" type="submit" style="margin-right: 5px; margin-top: 5px;" @click="exportCSV('missingPunchesCSV')"><icon name="file"></icon> Export</button>
              </div>
            </div>
          </div>

        </div>


      </div>



      <!------------------------------>
      <!-------Employee Detail-------->
      <!------------------------------>

      <div class="col content" v-if="selectedEmployee.name && searchFilters.resultsView == 'attendance'">

        <!--User Details Top Section-->
        <div class="row">
          <div class="col-md-12" style="margin: 20px;">
            <h1 align="center">TIMESHEET SUMMARY</h1>
            <h4 align="center">{{selectedEmployee.name}}</h4>
            <h3 align="center">
              {{$moment(searchFilters.dateFrom).format('DD MMM')}} to {{$moment(searchFilters.dateTo).format('DD MMM')}}
            </h3>
          </div>
        </div>
        <div class="row" style="background-color: rgba(0,0,0,0.03); padding: 5px;">

          <div class="col-md-4">
            <div class="row">
              <div class="col-md-3" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Name</strong></div>
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <router-link :to="'/hr/employees'+'#'+user.id">{{user.name}} -- {{user.name_lang}}</router-link>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Nationality</strong></div>
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                {{user.nationality.name}}
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Religion</strong></div>
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                {{user.religion.name}}
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>User ID</strong></div>
              <div class="col" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                {{user.id}}
              </div>
            </div>
          </div>


          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>City</strong></div>
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                {{user.city}}
              </div>
            </div>
          </div>


          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Position</strong></div>
              <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                {{user.designation.name}}
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Cost Company</strong></div>
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                {{selectedEmployee.company}}
              </div>
            </div>
          </div>


          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Sponsor Company</strong></div>
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                {{selectedEmployee.sponsorCompany}}
              </div>
            </div>
          </div>


          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Branch</strong></div>
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="branch in user.branches">{{findBranch(branch).name}}</span>
              </div>
            </div>
          </div>

          <div class="col-md-8">
            <div class="row">
              <div class="col-md-3" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Shift</strong><span style="cursor: pointer;" v-if="shiftToggle === true" class="float-right" @click="shiftToggleFunction">[+]</span><span style="cursor: pointer;" v-if="shiftToggle === false" class="float-right" @click="shiftToggleFunction">[-]</span></div>
              <div class="col" v-bind:class="[{ hideShiftsClass: shiftToggle }, showShiftsClass]"   style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="plan in selectedEmployee.shiftPlans">
                  <span v-if="findShiftPlan(plan).startDate <= findVisibilityEnd() && findShiftPlan(plan).endDate >= findVisibilityStart()">
                    <router-link :to="'/hr/shifts/shift-plans'+'#'+plan">{{findShiftPlan(plan).name}}</router-link> &nbsp;
                  </span>
                </span>
              </div>
            </div>
          </div>



          <div class="col-md-4">
            <div class="row">
              <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Department</strong></div>
              <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                <span v-for="department in user.departments">{{findDepartment(department).name}}</span>
              </div>
            </div>
          </div>

        </div>

        <!--User Details Table-->
        <div class="row" style="margin-top:20px;">

          <div class="col-md-12" v-if="selectedEmployee.attendances" v-show="!timesheetsListLoading">
            <!--Individual Employee Timesheets List Table-->
            <table  class="table table-hover" style="margin-top: -10px;">
              <thead>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Date</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Check In</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Break Start</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Break End</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Checkout</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Other Punches</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Remarks</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Status</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Missing Time</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Overtime</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Net Time</th>

              </thead>
              <tbody>
              <tr v-for="attendance in selectedEmployee.attendances" :style="[(attendance.diff == 1) ? {'background-color': '#FFB0B2'} : {}]">
                <td style="font-size: 12px; cursor: pointer;" @click="attendanceAlert(attendance.punches)">
                  <span :id="'s'+attendance.id"><icon name="calendar"></icon> </span> &nbsp; {{$moment(attendance.date).format('D MMM - ddd')}}
                  <b-popover :target="'s'+attendance.id" triggers="hover focus">
                    <strong>{{findShiftPlan(attendance.sp).name}}</strong>
                  </b-popover>
                </td>
                <td style="font-size: 12px; cursor: pointer;"  @click="updatePunches(attendance, '', attendance.date)">
                                    <span v-if="attendance.pIn">
                                        <span :id="'punch'+attendance.pIn.id" :style="[(attendance.pIn.psID == 1) ? {'color': 'black'} : {'color': 'orange'}]">
                                            {{$moment(attendance.pIn.stamp).format("hh:mm A")}}
                                        </span>
                                        <b-popover :target="'punch'+attendance.pIn.id" triggers="hover focus" v-if="attendance.pIn.branch > 0">
                                            <!--<template slot="title">Punch Details</template>-->
                                            <span v-if="findBranch(attendance.pIn.branch)"><strong>Branch:</strong> {{attendance.pIn.name}}</span>
                                        </b-popover>
                                    </span>

                  <span v-if="attendance.pInM == 1 && attendance.status != 3 && attendance.status != 2 && attendance.status != 6"><b-badge variant="warning">M.P.</b-badge></span>
                </td>
                <td style="font-size: 12px; cursor: pointer;" @click="updatePunches(attendance, '', attendance.date)">
                                    <span v-if="attendance.bStart">
                                        <span :id="'punch'+attendance.bStart.id" :style="[(attendance.bStart.psID == 1) ? {'color': 'black'} : {'color': 'orange'}]">
                                            {{$moment(attendance.bStart.stamp).format("hh:mm A")}}
                                        </span>
                                        <b-popover :target="'punch'+attendance.bStart.id" triggers="hover focus" v-if="attendance.bStart.branch > 0">
                                            <!--<template slot="title">Punch Details</template>-->
                                            <span v-if="findBranch(attendance.bStart.branch)"><strong>Branch:</strong> {{attendance.bStart.name}}</span>
                                        </b-popover>
                                    </span>
                  <span v-if="attendance.bStartM == 1 && attendance.status != 3 && attendance.status != 2 && attendance.status != 6"><b-badge variant="warning">M.P.</b-badge></span>
                </td>
                <td style="font-size: 12px; cursor: pointer;" @click="updatePunches(attendance, '', attendance.date)">
                                    <span v-if="attendance.bEnd">
                                        <span :id="'punch'+attendance.bEnd.id" :style="[(attendance.bEnd.psID == 1) ? {'color': 'black'} : {'color': 'orange'}]">
                                            {{$moment(attendance.bEnd.stamp).format("hh:mm A")}}
                                        </span>
                                        <b-popover :target="'punch'+attendance.bEnd.id" triggers="hover focus" v-if="attendance.bEnd.branch > 0">
                                            <!--<template slot="title">Punch Details</template>-->
                                            <span v-if="findBranch(attendance.bEnd.branch)"><strong>Branch:</strong> {{attendance.bEnd.name}}</span>
                                        </b-popover>
                                    </span>
                  <span v-if="attendance.bEndM == 1 && attendance.status != 3 && attendance.status != 2 && attendance.status != 6"><b-badge variant="warning">M.P.</b-badge></span>
                </td>
                <td style="font-size: 12px; cursor: pointer;" @click="updatePunches(attendance, '', attendance.date)">
                                    <span v-if="attendance.pOut">
                                        <span :id="'punch'+attendance.pOut.id" :style="[(attendance.pOut.psID == 1) ? {'color': 'black'} : {'color': 'orange'}]">
                                            {{$moment(attendance.pOut.stamp).format("hh:mm A")}}
                                        </span>
                                        <b-popover :target="'punch'+attendance.pOut.id" triggers="hover focus" v-if="attendance.pOut.branch > 0">
                                            <!--<template slot="title">Punch Details</template>-->
                                            <span v-if="findBranch(attendance.pOut.branch)"><strong>Branch:</strong> {{attendance.pOut.name}}</span>
                                        </b-popover>
                                    </span>
                  <span v-if="attendance.pOutM == 1 && attendance.status != 3 && attendance.status != 2 && attendance.status != 6"><b-badge variant="warning">M.P.</b-badge>&nbsp;</span>
                </td>
                <td style="font-size: 12px; cursor: pointer;" @click="updatePunches(attendance, '', attendance.date)">
                  <span v-if="attendance.pIn2 && attendance.pOut2">({{$moment(attendance.pIn2.stamp).format("hh:mm A")}} > {{$moment(attendance.pOut2.stamp).format("hh:mm A")}})</span>
                  <span v-if="attendance.pIn3 && attendance.pOut3"><br/>({{$moment(attendance.pIn3.stamp).format("hh:mm A")}} > {{$moment(attendance.pOut3.stamp).format("hh:mm A")}})</span>
                  <span v-if="attendance.pIn4 && attendance.pOut4"><br/>({{$moment(attendance.pIn4.stamp).format("hh:mm A")}} > {{$moment(attendance.pOut4.stamp).format("hh:mm A")}})</span>
                </td>

                <td style="font-size: 12px; cursor: pointer;">
                  <!--                                    {{attendance.comments}}-->
                  <span v-if="attendance.comments && permissionCheck('Comments','Read')">
                                        <span :id="'c'+attendance.id"><icon style="color: orange;" name="comment" scale="1.5"></icon></span>
                                        <b-popover :target="'c'+attendance.id" triggers="hover focus">
                                            <!--<template slot="title">Punch Details</template>-->
                                            <span v-for="comment in attendance.comments">
                                                <strong>{{findUser(comment.owner_id).name}}</strong> <br/>
                                                    <small>on {{$moment(comment.created_at).format('D MMM, YYYY - dddd')}}</small><br/>
                                                {{comment.description}}
                                                <hr/>
                                            </span>
                                        </b-popover>
                                    </span>
                  <span  v-if="permissionCheck('Comments','Create')" @click="addComments(attendance)">+</span>
                </td>

                <td style="font-size: 12px; cursor: pointer;">
                  <div v-if="attendance">
                    <span v-if="attendance.status == 1"><span class='badge badge-success'> PRESENT </span></span>
                    <span v-if="attendance.status == 2">
                        <span v-if="attendance.lID.leaveType" class='badge badge-primary'>{{findLeaveType(attendance.lID.leaveType).name}}</span>
                        <span v-else class='badge badge-primary'> LEAVE </span>
                    </span>
                    <span v-if="attendance.status == 3"><span class='badge badge-danger'> ABSENT </span></span>
                    <span v-if="attendance.status == 4"><span class='badge badge-secondary'> DAY OFF </span></span>
                    <span v-if="attendance.status == 5"><span class='badge badge-warning'> PENDING </span></span>
                    <span v-if="attendance.status == 6" class='badge badge-warning'>{{findHoliday(attendance.date).name}}</span>

                  </div>
                </td>

                <td style="font-size: 12px; cursor: pointer;" @click="adjustAttendance(attendance)">
                  <div v-if="attendance">
                    <strong style="color: #c00000;">
                      <span v-if="attendance.m > 0">
                        <icon name="cog"></icon>  {{attendance.m}} Minutes
                      </span>
                      <span v-if="attendance.m === 0 && permissionCheck('MissingOvertime','Read') && attendance.amc !== 0 " style="color:gray;">
                        <icon name="cog"></icon>  {{attendance.m}} Minutes
                      </span>
                      <span style="color:gray;" v-if="permissionCheck('MissingOvertime','Read') && attendance.amc !== 0">
                        ({{attendance.amc}})
                      </span>
                    </strong>
                  </div>
                </td>

                <td style="font-size: 12px; cursor: pointer;" @click="adjustAttendance(attendance)">
                  <div v-if="attendance">
                    <strong style="color: #008f0b;">
                      <span v-if="attendance.o > 0">
                        <icon name="cog"></icon>  {{attendance.o}} Minutes
                      </span>
                      <span v-if="attendance.o === 0 && permissionCheck('MissingOvertime','Read') && attendance.aoc !== 0 " style="color:gray;">
                        <icon name="cog"></icon>  {{attendance.o}} Minutes
                      </span>
                      <span style="color:gray;" v-if="permissionCheck('MissingOvertime','Read') && attendance.aoc !== 0">
                        ({{attendance.aoc}})
                      </span>
                    </strong>
                  </div>
                </td>

                <td style="font-size: 12px; cursor: pointer;">
                  <div v-if="attendance">
                    <span>{{converter(attendance.net)}}</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>

            <!--Display Individual Employee Totals For the Month-->
            <div class="row">
              <div class="col-md-4" >
                <table  class="table table-hover" style="margin-top: -10px;">

                  <thead>
                  <th scope="col" style="font-size: 12px; background-color: #ffce9a; text-align: center;" align="center">Calculated</th>
                  <th scope="col" style="font-size: 12px; background-color: #ffce9a; text-align: center;" align="center">Adjusted</th>
                  <th scope="col" style="font-size: 12px; background-color: #ffce9a; text-align: center;" align="center">Missing Net</th>
                  </thead>

                  <tbody>
                  <tr>
                    <td align="center">{{converter((selectedEmployee.missingCalculated/60).toFixed(2))}} Hrs</td>
                    <td align="center">{{(converter(selectedEmployee.missingAdjusted/60))}}</td>
                    <td align="center">{{converter((selectedEmployee.missingFinal/60).toFixed(2))}} Hrs</td>

                  </tr>
                  </tbody>

                </table>
              </div>

              <div class="col-md-4">
                <table  class="table table-hover" style="margin-top: -10px;">

                  <thead>
                  <th scope="col" style="font-size: 12px; background-color: #ddffb1; text-align: center;">Calculated</th>
                  <th scope="col" style="font-size: 12px; background-color: #ddffb1; text-align: center;">Adjusted</th>
                  <th scope="col" style="font-size: 12px; background-color: #ddffb1; text-align: center;">Overtime Net</th>
                  </thead>

                  <tbody>
                  <tr>
                    <td align="center">{{converter((selectedEmployee.overtimeCalculated/60).toFixed(2))}} Hrs</td>
                    <td align="center">{{converter((selectedEmployee.overtimeAdjusted/60))}} Hrs</td>
                    <td align="center">{{converter((selectedEmployee.overtimeFinal/60).toFixed(2))}} Hrs</td>
                  </tr>
                  </tbody>

                </table>
              </div>

              <div class="col-md-4">
                <table  class="table table-hover" style="margin-top: -10px;">

                  <thead>
                  <th scope="col" style="font-size: 12px; text-align: center;">Missed Punches</th>
                  <th scope="col" style="font-size: 12px; background-color: #ff9398; text-align: center;">Absense</th>
                  <th scope="col" style="font-size: 12px; background-color: #e6f6ff; text-align: center;">Leaves</th>
                  <th scope="col" style="font-size: 12px; background-color: #b4d6ff; text-align: center;">Total Hours</th>
                  </thead>

                  <tbody>
                  <tr>
                    <td align="center">{{missedPunches}}</td>
                    <td align="center">{{selectedEmployee.absences}}</td>
                    <td align="center">{{selectedEmployee.leaves}}</td>
                    <td align="center">{{converter(selectedEmployee.totalHours)}} Hrs</td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>

          </div>

        </div>

      </div>

      <!-- Search Filter Modal -->
      <form @submit.prevent="onSearchFilters">
        <b-modal ref="searchFilter" size="lg" centered >
          <div slot="modal-header">
            <h3>Time and Attendance: Search Filter</h3>
          </div>

          <b-container fluid>

            <div class="form-group row">
              <div class="col">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Date From</strong></small>
                <date-picker
                    v-model="dateSelect.dateFrom"
                    type="date"
                    @change="setDateFrom"
                    :placeholder = "searchFilters.dateFrom"
                    format="dd-MM-yyyy"
                    :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                    lang="en">
                </date-picker>
              </div>

              <div class="col">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Date To</strong></small>
                <date-picker
                    v-model="dateSelect.dateTo"
                    type="date"
                    @change="setDateTo"
                    :placeholder = "searchFilters.dateTo"
                    format="dd-MM-yyyy"
                    :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                    lang="en">
                </date-picker>
              </div>
            </div>

            <div class="form-group row">
              <div class="col">
                <small class="form-text text-muted"> <icon name="building"></icon> <strong>Cost Company</strong></small>
                <multiselect
                    v-model="searchFilters.companies2"
                    :options="companies"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCostCompany"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>

              <div class="col">
                <small class="form-text text-muted"> <icon name="building"></icon> <strong>Sponsor Company</strong></small>
                <multiselect
                    v-model="searchFilters.sponsorCompanies2"
                    :options="sponsorCompanies"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectSponsorCompany"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>
            </div>

            <div class="form-group row">
              <div class="col">
                <small class="form-text text-muted"> <icon name="building"></icon> <strong>Branch</strong></small>
                <multiselect
                    v-model="searchFilters.branches2"
                    :options="branches"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectBranches"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>

              <div class="col">
                <small class="form-text text-muted"> <icon name="list"></icon> <strong>Departments</strong></small>
                <multiselect
                    v-model="searchFilters.departments2"
                    :options="departments"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectDepartments"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>
            </div>

            <div class="form-group row">
              <div class="col">
                <small class="form-text text-muted"> <icon name="map-pin"></icon> <strong>City</strong></small>
                <multiselect
                    v-model="searchFilters.cities2"
                    :options="cities"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCities"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>

              <div class="col">
                <small class="form-text text-muted"> <icon name="globe"></icon> <strong>Nationality</strong></small>
                <multiselect
                    v-model="searchFilters.nationalities2"
                    :options="nationalities"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectNationalities"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>
            </div>

            <div class="form-group row">
              <div class="col">
                <small class="form-text text-muted"> <icon name="briefcase"></icon> <strong>Designation</strong></small>
                <multiselect
                    v-model="searchFilters.designations2"
                    :options="designations"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectDesignations"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>

              <div class="col">
                <small class="form-text text-muted"> <icon name="book"></icon> <strong>Religion</strong></small>
                <multiselect
                    v-model="searchFilters.religions2"
                    :options="religions"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectReligions"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>
            </div>

            <div class="form-group row">

              <div class="col">
                <small class="form-text text-muted"> <icon name="users"></icon> <strong>Employee</strong></small>
                <multiselect
                    v-model="searchFilters.employees2"
                    :options="users"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder="Search By Name"
                    @input="onSelectUsers"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.id }} - {{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.id }} - {{ props.option.name }}
                  </template>
                </multiselect>
              </div>
              <div class="col">
                <small class="form-text text-muted"> <icon name="users"></icon> <strong>Employee</strong></small>
                <multiselect
                    v-model="searchFilters.employees2"
                    :options="users"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder="Search By ID"
                    @input="onSelectUsers"
                    label="id"
                    track-by="id"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        {{ props.option.id }}
                                      <!--                                        <span> - {{ props.option.name }}</span>-->
                                      <!--                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>-->
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.id }} - {{ props.option.name }}
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <small class="form-text text-muted"> <icon name="refresh"></icon> <strong>Shift Plan</strong></small>
                <multiselect
                    v-model="searchFilters.shiftPlans2"
                    :options="shiftPlans"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectShiftPlans"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>
              <div class="col">
                <small class="form-text text-muted"> <icon name="building"></icon> <strong>Status</strong></small>
                <multiselect
                    v-model="searchFilters.status2"
                    :options="statuses"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectStatus"
                    label="name"
                    track-by="name"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ props.option.name }}
                  </template>
                </multiselect>
              </div>
            </div>
          </b-container>

          <div slot="modal-footer">
            <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('attendance')"><icon name="calendar"></icon> Attendance</button>
            <button class="btn btn-warning float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('missed')"><icon name="times"></icon> Missed Punches</button>
            <button class="btn btn-danger float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('absent')"><icon name="warning"></icon> Absences</button>
            <button class="btn btn-dark float-right" type="reset" style="margin-right: 5px;" @click="searchFilterClear('open')"><icon name="minus-square"></icon> Clear Filters</button>
            <button class="btn btn-danger-outline float-right" type="button" style="margin-right: 5px;" @click="$refs.searchFilter.hide()"><icon name="times"></icon> Cancel</button>
          </div>
        </b-modal>
      </form>

      <!-- Attendance Missing / Overtime-->
      <form  v-if="permissionCheck('MissingOvertime','Update')" @submit.prevent="updateMissingOvertimeForm">
        <b-modal ref="updateAttendance" size="lg" centered >
          <div slot="modal-header">
            <h3>UPDATE MISSING AND OVERTIME</h3>
          </div>

          <b-container fluid>

            <div class="row">
              <div class="col-md-12">
                <h3 align="center">
                  <icon name="user" scale="3"></icon><br/>
                  {{selectedEmployee.name}}
                </h3>
                <h5 align="center">{{$moment(selectedAttendance.date).format('dddd - D MMMM YYYY')}}</h5>
              </div>

              <div class="col-md-6">
                <h5 align="center">
                  <icon name="warning" scale="3"></icon><br/>
                  ADJUST MISSING TIME
                </h5>
                <div class="row">
                  <div class="col-md-6"><strong>Calculate Missing Time:</strong></div>
                  <div class="col-md-6"><strong>{{selectedAttendance.mc}} minutes</strong></div>
                </div>
                <div class="row">
                  <div class="col-md-6"><strong>Manually Adjusted Missing: </strong></div>
                  <div class="col-md-6"><strong>{{selectedAttendance.amc}} minutes</strong></div>
                </div>
                <div class="row">
                  <div class="col-md-6"><strong>Total Missing Time: </strong></div>
                  <div class="col-md-6"><strong>{{selectedAttendance.m}} minutes</strong></div>
                </div>

                <p>
                  <br/>
                  <input v-model="updateMissingOvertime.adjustedMissing" type="number" min="-600" max="600" style="width: 275px;" />
                  <br/>
                </p>

                <div class="row">
                  <div class="col-md-6"><strong>New Missing Time: </strong></div>
                  <div class="col-md-6"><strong>{{newMissingTime}} minutes</strong></div>
                </div>

              </div>

              <div class="col-md-6">
                <h5 align="center">
                  <icon name="calendar" scale="3"></icon><br/>
                  ADJUST OVERTIME
                </h5>

                <div class="row">
                  <div class="col-md-6"><strong>Calculated Overtime:</strong></div>
                  <div class="col-md-6"><strong>{{selectedAttendance.oc}} minutes</strong></div>
                </div>
                <div class="row">
                  <div class="col-md-6"><strong>Manually Adjusted Overtime: </strong></div>
                  <div class="col-md-6"><strong>{{selectedAttendance.aoc}} minutes</strong></div>
                </div>
                <div class="row">
                  <div class="col-md-6"><strong>Total Overtime: </strong></div>
                  <div class="col-md-6"><strong>{{selectedAttendance.a}} minutes</strong></div>
                </div>

                <p>
                  <br/>
                  <input v-model="updateMissingOvertime.adjustedOvertime" type="number" min="-600" max="600" style="width: 275px;" />
                  <br/>
                </p>

                <div class="row">
                  <div class="col-md-6"><strong>New Overtime: </strong></div>
                  <div class="col-md-6"><strong>{{newOvertime}} minutes</strong></div>
                </div>

              </div>

            </div>

          </b-container>

          <div slot="modal-footer">
            <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;"><icon name="calendar"></icon> Adjust Times</button>
            <button class="btn btn-danger float-right" type="button" style="margin-right: 5px;" @click="$refs.updateAttendance.hide()"><icon name="times"></icon> Cancel</button>
          </div>
        </b-modal>
      </form>

      <!-- Punches Adjustments -->
      <form @submit.prevent="updatePunchesOrder">
        <b-modal ref="updatePunchesOrder" size="lg" centered >
          <!--<div slot="modal-header">-->
          <!--<h3 align="center">UPDATE ATTENDANCE PUNCHES</h3>-->
          <!--</div>-->

          <b-container fluid>

            <div class="row" v-if="selectedEmployee">
              <div class="col-md-12">
                <h3 align="center">
                  <icon name="user" scale="3"></icon><br/>
                  {{selectedEmployee.name}}
                </h3>
                <h5 align="center">{{$moment(selectedAttendance.date).format('dddd - D MMMM YYYY')}} (<span style="color:orangered;">{{selectedAttendancePolicy.policy_name}} Policy</span>)</h5>
              </div>
            </div>


            <div class="form-group row">
              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).checkIn">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Check In <span v-if="selectedAttendance"><span v-if="selectedAttendance.pInM" class='badge badge-warning'>Missed Punch</span></span> </strong></small>
                <multiselect
                    v-model="multiSelect.checkIn"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCheckIn"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>
                                            {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }}
                                            ({{props.option.type}})
                                            <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                            <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                        </span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>

              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).checkOut">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Check Out <span v-if="selectedAttendance"><span v-if="selectedAttendance.pOutM" class='badge badge-warning'>Missed Punch</span></span> </strong></small>
                <multiselect
                    v-model="multiSelect.checkOut"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCheckOut"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                                                                  <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>

                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>
            </div>


            <div class="form-group row">
              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).breakStart">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Break Start <span v-if="selectedAttendance"><span v-if="selectedAttendance.bStartM" class='badge badge-warning'>Missed Punch</span></span> </strong></small>
                <multiselect
                    v-model="multiSelect.breakStart"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectBreakStart"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                        <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                      <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>

              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).breakEnd">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Break End <span v-if="selectedAttendance"><span v-if="selectedAttendance.bEndM" class='badge badge-warning'>Missed Punch</span></span> </strong></small>
                <multiselect
                    v-model="multiSelect.breakEnd"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectBreakEnd"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                        <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                      <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>
            </div>


            <div class="form-group row">
              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).checkIn2">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Check In 2</strong></small>
                <multiselect
                    v-model="multiSelect.checkIn2"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCheckIn2"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                        <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                      <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>

              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).checkOut2">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Check Out 2</strong></small>
                <multiselect
                    v-model="multiSelect.checkOut2"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCheckOut2"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                        <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                      <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>
            </div>


            <div class="form-group row">
              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).checkIn3">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Check In 3</strong></small>
                <multiselect
                    v-model="multiSelect.checkIn3"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCheckIn3"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                        <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                      <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>

              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).checkOut3">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Check Out 3</strong></small>
                <multiselect
                    v-model="multiSelect.checkOut3"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCheckOut3"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                        <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                      <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>
            </div>


            <div class="form-group row">
              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).checkIn4">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Check In 4</strong></small>
                <multiselect
                    v-model="multiSelect.checkIn4"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCheckIn4"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                        <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                      <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>

              <div class="col" v-if="attendancePolicyCheck(selectedAttendance.pID).checkOut4">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Check Out 4</strong></small>
                <multiselect
                    v-model="multiSelect.checkOut4"
                    :options="unassignedPunches"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder=""
                    @input="onSelectCheckOut4"
                    label="stamp"
                    track-by="stamp"
                    :max="1"
                    :preselect-first="false">
                  <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})</span>
                                        <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                                        <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                                      <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    {{ $moment(props.option.stamp).format('hh:mm A - ddd, DD MMM') }} ({{props.option.type}})
                    <span v-if="findBranch(props.option.branch)"> -- {{props.option.name}}</span>
                    <span v-if="findUser(props.option.rUID)"> -- {{findUser(props.option.rUID).name}}</span>
                  </template>
                </multiselect>
              </div>

            </div>


            <div v-if="permissionCheck('Punches','Create')" class="col">
              <h5 align="center">
                <icon name="check" scale="3"></icon>
                &nbsp;&nbsp;
                Add a Missing Punch:
                &nbsp;&nbsp;
                <date-picker
                    v-model="dateSelect.punchDate"
                    type="datetime"
                    @change="setDateMissingPunch"
                    :placeholder = "missingPunchForm.punchDate"
                    format="dd-MM-yyyy HH:mm"
                    lang="en" confirm>
                </date-picker>
                &nbsp;&nbsp;
                <button class="btn btn-primary" type="button" @click="addMissingPunch"><icon name="calendar"></icon> Add a Missing Punch</button>
              </h5>
            </div>


          </b-container>

          <div slot="modal-footer">
            <button v-if="permissionCheck('Punches','Update')" class="btn btn-success float-right" type="submit" style="margin-right: 5px;"><icon name="calendar"></icon> Adjust Punches</button>
            <button class="btn btn-danger float-right" type="button" style="margin-right: 5px;" @click="$refs.updatePunchesOrder.hide()"><icon name="times"></icon> Cancel</button>
          </div>
        </b-modal>
      </form>

      <!-- Leave Request Modal -->
      <form v-if="permissionCheck('Leaves','Create')" @submit.prevent="storeLeave(selectedEmployee.id)">
        <b-modal ref="leaveForm" size="lg" centered >
          <div align="center" slot="modal-header">
            <h3 align="center">Leave Application Form</h3>
          </div>

          <b-container fluid>

            <div class="row" v-if="selectedEmployee">
              <div class="col-md-12">
                <h3 align="center">
                  <icon name="user" scale="3"></icon><br/>
                  {{selectedEmployee.name}}
                </h3>
                <h5 align="center">{{$moment(selectedAttendance.date).format('dddd - D MMMM YYYY')}}</h5>
              </div>
            </div>

            <div class="form-group row">
              <div class="col">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Date From</strong></small>
                <date-picker
                    v-model="dateSelect.leaveDateFrom"
                    type="date"
                    @change="setLeaveDateFrom"
                    :placeholder = "leaveForm.dateFrom"
                    format="dd-MM-yyyy"
                    :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                    lang="en">
                </date-picker>
              </div>

              <div class="col">
                <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Date To</strong></small>
                <date-picker
                    v-model="dateSelect.leaveDateTo"
                    type="date"
                    @change="setLeaveDateTo"
                    :placeholder = "searchFilters.dateTo"
                    format="dd-MM-yyyy"
                    :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                    lang="en">
                </date-picker>
              </div>

              <div class="col">
                <small class="form-text text-muted"> <icon name="envelope"></icon> <strong>Leave Type</strong></small>
                <select class="form-control" v-model="leaveForm.leaveType">
                  <option v-for="option in leaveOptions" v-bind:value="option.id">
                    {{ option.name }}
                  </option>
                </select>
              </div>

            </div>

            <div class="form-group row">


              <div class="col">
                <small class="form-text text-muted"> <icon name="users"></icon> <strong>Description</strong></small>
                <textarea v-model="leaveForm.description" class="form-control" rows="5" id="descriprion" name="description"></textarea>
              </div>
            </div>

            <div class="row">

            </div>

          </b-container>

          <div slot="modal-footer">
            <button class="btn btn-success float-right" type="button" style="margin-right: 5px;" @click="storeLeave(selectedEmployee.id)"><icon name="envelope"></icon> Save Application</button>
            <button class="btn btn-danger float-right" type="button" style="margin-right: 5px;" @click="$refs.leaveForm.hide()"><icon name="times"></icon> Cancel</button>
          </div>
        </b-modal>
      </form>

      <!-- Add New Comment-->
      <form v-if="permissionCheck('Comments','Create')">
        <b-modal ref="commentForm" size="lg" centered >
          <div align="center" slot="modal-header">
            <h3 align="center">Add New Comment</h3>
          </div>

          <b-container fluid>

            <h6>Please use the text box below to add your remarks.</h6>

            <div class="form-group row">
              <div class="col">
                <small class="form-text text-muted"> <icon name="users"></icon> <strong>Comments</strong></small>
                <textarea v-model="commentForm.description" class="form-control" rows="5" id="comments" name="comments" required></textarea>
              </div>
            </div>

            <div class="row">
              <!--                        {{commentForm}}-->
            </div>

          </b-container>

          <div slot="modal-footer">
            <button class="btn btn-success float-right" type="button" style="margin-right: 5px;" @click="storeComment()"><icon name="comment"></icon> Save Comment</button>
            <button class="btn btn-danger float-right" type="button" style="margin-right: 5px;" @click="$refs.commentForm.hide()"><icon name="times"></icon> Cancel</button>
          </div>
        </b-modal>
      </form>

    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import router from './../../../router'
    import {Form, Errors} from '@/components/validations/forms';
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        name: 'Dashboard',
        components: {},
        data () {
            return {
                menuItems: [
                    {name: 'Timesheet & Attendance', link:'', icon: 'calendar', toggle: false, children: [
                            {name: 'Search Timesheet', link:'/hr/attendance/search-attendance', icon: ''},
                            {name: 'Missed Punches', link:'/hr/attendance/search-attendance#1', icon: ''},
                            {name: 'Absent Employees', link:'/hr/attendance/search-attendance#2', icon: ''},
                        ]},
                ],
                // Loaders
                timesheetsListLoading: false,
                timesheetsDetailsLoading: false,

                toggle: {
                    leftNavigation : true,
                    rightNavigation : true,
                },
                shiftToggle: true,

                error: null,

                companies: this.$store.getters['environment/getCompanies'],
                sponsorCompanies: this.$store.getters['environment/getSponsorCompanies'],
                divisions: this.$store.getters['environment/getDivisions'],
                branches: this.$store.getters['environment/getBranches'],
                departments: this.$store.getters['environment/getDepartments'],
                designations: this.$store.getters['environment/getDesignations'],
                religions: this.$store.getters['environment/getReligions'],
                nationalities: this.$store.getters['environment/getNationalities'],
                groups: this.$store.getters['environment/getGroups'],
                cities: this.$store.getters['environment/getCities'],
                users: this.$store.getters['user/getUsers'],
                shiftPlans: this.$store.getters['shifts/getShiftPlans'],
                shiftDayPolicies: this.$store.getters['shifts/getShiftDayPolicies'],
                user: null,

                // Timesheet List Related
                timesheetsList: [],
                timesheetsPages: null,
                timesheetsPaginationObject: {
                    totalRecords : 0,
                    totalPages : 0,
                    currentPage : 0,
                    first : 0,
                    firstActive : false,
                    previous : 0,
                    previousActive : false,
                    next : 0,
                    nextActive : false,
                    last : 0,
                    lastActive : false,
                },
                searchFilters: this.$store.getters['attendance/getSearchFilters'],
                sorting: this.$store.getters['attendance/getSorting'],
                dropdownx: this.$route.hash.substring(1),
                resultsView: "attendance",

                selectedEmployee: {},
                selectedAttendance: {
                    pUnknown: [],
                },
                selectedAttendancePolicy: {policy_name: null},
                companies2: [],
                companies3: [],

                // Forms
                storeTicket: new Form({
                    company_channels_id: null,
                    ticket_types_id: null,
                    customers_id: null,
                    customerEmail: null,
                    customerTitle: null,
                    customerFirstName: null,
                    customerLastName: null,
                    customerTelephone: null,
                    orders_id: null,
                    subject: null,
                    customerFindMode: true,
                    customerFindError: null,
                    customerCreateMode: false,
                }),
                updateMissingOvertime: new Form({
                    attendance_id: null,
                    adjustedMissing: null,
                    adjustedOvertime: null,
                }),
                punchFilters: new Form({
                    attendanceID: null,
                    checkIn: null,
                    checkOut: null,
                    breakStart: null,
                    breakEnd: null,
                    checkIn2: null,
                    checkOut2: null,
                    checkIn3: null,
                    checkOut3: null,
                    checkIn4: null,
                    checkOut4: null,
                }),
                missingPunchForm: new Form({
                    attendanceID: null,
                    punchDate: null,
                    userID: null,
                }),
                leaveForm: new Form({
                    dateFrom: null,
                    dateTo: null,
                    userID: null,
                    description: null,
                    leaveType: null,
                }),



                leaveOptions: this.$store.getters['leaves/getLeaveTypes'],


                commentForm: new Form({
                    description: null,
                    users_id: null,
                    commentDate: null,
                }),
            }
        },
        methods: {

            converter(decimals){
                let negative = false;
                if(decimals < 0){decimals = -decimals; negative = true;}
                decimals = decimals * 60;
                if(negative){
                    let result = Math.floor(decimals / 60) + ':' + (decimals % 60).toFixed(0).padStart(2, "0")
                    return '-' + result;
                }
                return Math.floor(decimals / 60) + ':' + (decimals % 60).toFixed(0).padStart(2, "0")
            },

            addComments(timesheet){
                this.show
                this.commentForm.description = null;
                this.commentForm.users_id = timesheet.uID;
                this.commentForm.commentDate = timesheet.date;
                this.$refs.commentForm.show()
            },
            storeComment(){
                this.$store.dispatch('attendance/storeComment', this.commentForm)
                    .then(response => {
                        this.updateEmployeeTimesheets()
                        this.$refs.commentForm.hide()
                        this.$snotify.success('Your comment has been posted succussfully');
                    })
                    .catch(error => {
                        // this.updateEmployee(this.commentForm.users_id)
                        this.$snotify.error('There was an error in posting your comment.');
                    })
            },

            shiftToggleFunction(){
                if(this.shiftToggle === true){
                    this.shiftToggle = false;
                } else{this.shiftToggle = true;}
            },

            ////////////////////////////////////////////////////
            // Multi List Dropdown Cleanup Functions Based
            ////////////////////////////////////////////////////
            // These methods clean up objects of selected options and make an array of IDs in search filter form
            onSelectCostCompany(value){this.searchFilters.companies = value.map(a => a.id);},
            onSelectSponsorCompany(value){this.searchFilters.sponsorCompanies = value.map(a => a.id);},
            onSelectBranches(value){this.searchFilters.branches = value.map(a => a.id);},
            onSelectDepartments(value){this.searchFilters.departments = value.map(a => a.id);},
            onSelectCities(value){this.searchFilters.cities = value.map(a => a.name);},
            onSelectNationalities(value){this.searchFilters.nationalities = value.map(a => a.id);},
            onSelectDesignations(value){this.searchFilters.designations = value.map(a => a.id);},
            onSelectReligions(value){this.searchFilters.religions = value.map(a => a.id);},
            onSelectShiftPlans(value){this.searchFilters.shiftPlans = value.map(a => a.id);},
            onSelectUsers(value){this.searchFilters.employees = value.map(a => a.id);},
            onSelectStatus(value){this.searchFilters.status = value.map(a => a.id);},


            onSelectCheckIn(value){if(value.length  > 0){this.punchFilters.checkIn = value.map(a => a.id)[0];} else {this.punchFilters.checkIn = null;}},
            onSelectCheckOut(value){if(value.length  > 0){this.punchFilters.checkOut = value.map(a => a.id)[0];} else {this.punchFilters.checkOut = null;}},
            onSelectBreakStart(value){if(value.length  > 0){this.punchFilters.breakStart = value.map(a => a.id)[0];} else {this.punchFilters.breakStart = null;}},
            onSelectBreakEnd(value){if(value.length  > 0){this.punchFilters.breakEnd = value.map(a => a.id)[0];} else {this.punchFilters.breakEnd = null;}},
            onSelectCheckIn2(value){if(value.length  > 0){this.punchFilters.checkIn2 = value.map(a => a.id)[0];} else {this.punchFilters.checkIn2 = null;}},
            onSelectCheckOut2(value){if(value.length  > 0){this.punchFilters.checkOut2 = value.map(a => a.id)[0];} else {this.punchFilters.checkOut2 = null;}},
            onSelectCheckIn3(value){if(value.length  > 0){this.punchFilters.checkIn3 = value.map(a => a.id)[0];} else {this.punchFilters.checkIn3 = null;}},
            onSelectCheckOut3(value){if(value.length  > 0){this.punchFilters.checkOut3 = value.map(a => a.id)[0];} else {this.punchFilters.checkOut3 = null;}},
            onSelectCheckIn4(value){if(value.length  > 0){this.punchFilters.checkIn4 = value.map(a => a.id)[0];} else {this.punchFilters.checkIn4 = null;}},
            onSelectCheckOut4(value){if(value.length  > 0){this.punchFilters.checkOut4 = value.map(a => a.id)[0];} else {this.punchFilters.checkOut4 = null;}},

            setDateFrom(){
                if(this.dateSelect.dateFrom){
                    this.searchFilters.dateFrom = this.$moment(this.dateSelect.dateFrom).format('YYYY-MM-DD');
                } else{this.searchFilters.dateFrom = this.$moment().format('YYYY-MM-DD')}
            },
            setDateTo(){
                if(this.dateSelect.dateTo){
                    this.searchFilters.dateTo = this.$moment(this.dateSelect.dateTo).format('YYYY-MM-DD');
                } else{this.searchFilters.dateTo = this.$moment().format('YYYY-MM-DD')}
            },
            setDateMissingPunch(){
                if(this.dateSelect.punchDate){
                    this.missingPunchForm.punchDate = this.$moment(this.dateSelect.punchDate).format('YYYY-MM-DD HH:mm:ss');
                }
            },
            setLeaveDateFrom(){
                if(this.dateSelect.leaveDateFrom){
                    this.leaveForm.dateFrom = this.$moment(this.dateSelect.leaveDateFrom).format('YYYY-MM-DD');
                } else{this.leaveForm.dateFrom = this.$moment().format('YYYY-MM-DD')}
            },
            setLeaveDateTo(){
                if(this.dateSelect.leaveDateTo){
                    this.leaveForm.dateTo = this.$moment(this.dateSelect.leaveDateTo).format('YYYY-MM-DD');
                } else{this.leaveForm.dateTo = this.$moment().format('YYYY-MM-DD')}
            },
            storeLeave(id){
                this.leaveForm.userID = id;
                if(!this.leaveForm.userID || !this.leaveForm.dateFrom || !this.leaveForm.dateTo || !this.leaveForm.leaveType)
                {alert('Please enter all details required for leave application')}
                else{
                    this.$store.dispatch('leaves/storeLeave', this.leaveForm)
                        .then(response => {
                            this.updateRecordsList(this.timesheetsPaginationObject.currentPage);
                            this.$refs.leaveForm.hide();
                            this.$snotify.success('Leave Application Saved');
                        })
                        .catch(error => {
                            this.shiftUpdateForm.onFail(error);
                            this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);
                        })
                }

                // alert(JSON.stringify(this.leaveForm))
            },

            ///////////////////////////////////////
            // Search Filter Functions
            ///////////////////////////////////////
            // This method clears the search filter popup and fetches in new records based on criteria
            searchFilterRecords(view){
                if(this.searchFilters.dateFrom && this.searchFilters.dateTo){
                    if(this.searchFilters.dateTo > this.searchFilters.dateFrom){
                        this.searchFilters.resultsView = view;
                        this.searchFilters.isActive = true;
                        this.$refs.searchFilter.hide();
                        this.updateRecordsList();
                    } else{this.$snotify.error("Date To cannot be before Date From");}

                } else{this.$snotify.error("Please choose the date range");}

            },

            exportCSV(view){
                this.timesheetsListLoading = true;
                return axios.request({
                    method: 'GET',
                    responseType: 'blob',
                    url: '/api/attendance/user',
                    params: {
                        companies: this.searchFilters.companies,
                        sponsorCompanies: this.searchFilters.sponsorCompanies,
                        branches: this.searchFilters.branches,
                        departments: this.searchFilters.departments,
                        cities: this.searchFilters.cities,
                        nationalities: this.searchFilters.nationalities,
                        designations: this.searchFilters.designations,
                        religions: this.searchFilters.religions,
                        shiftPlans: this.searchFilters.shiftPlans,
                        dateFrom: this.searchFilters.dateFrom,
                        dateTo: this.searchFilters.dateTo,
                        employees: this.searchFilters.employees,
                        status: this.searchFilters.status,
                        resultsView: view,
                        limit: this.sorting.limit,
                        page: this.sorting.page,
                        sortBy: this.sorting.sortBy,
                        sortOrder: this.sorting.sortOrder,
                    },

                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Timesheet Report ('+this.searchFilters.dateFrom+' - '+this.searchFilters.dateTo+').csv');
                    document.body.appendChild(link);
                    link.click();
                    this.timesheetsListLoading = false;

                })
                    .catch(error => {
                        this.timesheetsListLoading = false;
                    });
            },

            // This method clears the search filter results and selected criteria load default open tickets page
            searchFilterClear(redirect){
                this.searchFilters = null;
                this.searchFilters = JSON.parse(JSON.stringify(this.$store.getters['attendance/getDefaultSearchFilters']));
                this.$store.dispatch('attendance/resetSearchFilters');
                this.dateSelect = {};
                this.multiselect = {};
                this.searchFilters.isActive = false;
                this.timesheetsList = [];
                this.$forceUpdate();
                this.$refs.searchFilter.hide()
            },
            // This method will perform functions once the search filter form is submitted.
            onSearchFilters(){
                //
            },



            ////////////////////////////////////////////////////////////////////////
            // Helper functions to select the objects by searching through ID
            ////////////////////////////////////////////////////////////////////////

            findTimesheet(employeeID, datex, arrayx){
                let punchHtml = "";
                if(arrayx.length > 0) {
                    for (let s of arrayx) {
                        if(s.date == datex){
                            return [s]
                        }
                    }
                }
                return punchHtml;
            },
            findPunch(punchTypeID, attPunch, required){
                let target = 0;
                let html = "";

                for (let s of attPunch) {
                    let requiredCheck = 0;
                    if(this.requiredPunch(punchTypeID, required) == s.ptID)
                    {requiredCheck = 1;}

                    if(s.ptID == punchTypeID){
                        html = this.$moment(s.stamp).format("HH:mm");
                        if(requiredCheck == 1){target = 2;}
                    }
                    if(requiredCheck == 1 && target == 0) {
                        html = "<span class='badge badge-warning'>MP</span>";
                    }
                }
                return html;
            },
            requiredPunch(punchTypeID, requiredPuncheTypes){
                let punchesTypes = requiredPuncheTypes;
                let result = 0;
                for (let s of punchesTypes) {
                    if(s == punchTypeID){
                        result = 1;
                    }
                }
                return result;
            },
            findAttendancePolicy(){
                if(this.selectedAttendance.pID){
                    this.selectedAttendancePolicy = this.findShiftDayPolicy(this.selectedAttendance.pID)
                }
                return this.selectedAttendancePolicy;
            },


            ///////////////////////////////////
            // General Helper Functions
            ///////////////////////////////////
            // Method to control the visibility of different sections of the page based on several criteria
            visibility(postionName){
                if(postionName === 'leftNavigation')
                {
                    if(this.iScreen(['lg','md']) && this.toggle.leftNavigation){return true;}
                }
                if(postionName === 'leftNavigationCollapsed')
                {
                    if(this.iScreen(['lg','md']) && !this.toggle.leftNavigation){return true;}
                }
                if(postionName === 'rightToolsTicket')
                {
                    if(this.iScreen(['lg','md']) && this.selectedTicket && this.toggle.rightNavigation){return true;}
                }
                if(postionName === 'leftListTicketsHeading')
                {
                    if(this.iScreen(['md']) && this.selectedTicket && !this.toggle.leftNavigation){return true;}
                    if(this.iScreen(['lg']) && this.selectedTicket) {return true;}
                }
                if(postionName === 'leftListTickets')
                {
                    if(this.iScreen(['md']) && this.selectedTicket && !this.toggle.leftNavigation){return true;}
                    if(this.iScreen(['lg']) && this.selectedTicket) {return true;}
                }
                if(postionName === 'ticketList')
                {
                    if(!this.selectedTicket){return true;}
                }
                if(postionName === 'ticketDetail')
                {
                    if(this.selectedTicket){return true;}
                }
                if(postionName === 'search')
                {
                    if(!this.selectedTicket && this.$route.hash.substring(1) === 'search'){return true;}
                }
                return false;
            },
            // This method changes true/false visibility of sections (shrink/expand) or (show/hide)
            toggleSection(sectionName){
                if(sectionName === 'leftNavigation'){this.toggle.leftNavigation = !this.toggle.leftNavigation}
                if(sectionName === 'rightNavigation'){this.toggle.rightNavigation = !this.toggle.rightNavigation}
            },
            // Helper function to sort an array by the key, like sortOrder.
            sortByKey(array, key) {
                return array.sort(function(a, b) {
                    let x = a[key]; let y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            },
            // Update Tickets Pagination Object
            updateTicketsPaginationObject(){
                let paginationObject = null;

                let totalRecords = 0;
                let totalPages = 1;
                let currentPage = 1;
                let first = 1;
                let firstActive = false;
                let previous = 1;
                let previousActive = false;
                let next = 1;
                let nextActive = false;
                let last = 1;
                let lastActive = false;

                if(this.timesheetsPages['meta']){paginationObject = this.timesheetsPages['meta'];}
                if(paginationObject){
                    totalRecords = paginationObject.total;
                    totalPages = paginationObject.last_page;
                    currentPage = paginationObject.current_page;
                    first = 1;
                    if(currentPage > 1){previous = currentPage - 1;} else{previous = 1}
                    if(currentPage < totalPages){next = currentPage + 1;} else{next = totalPages}
                    last = paginationObject.last_page;

                    if(totalPages === 1){firstActive = false; previousActive = false; nextActive = false; lastActive = false;}
                    else{
                        if(currentPage > previous){firstActive = true; previousActive = true;}
                        if(currentPage < next){nextActive = true; lastActive = true;}
                        if(currentPage < next && currentPage > previous){firstActive = true; previousActive = true; nextActive = true; lastActive = true;}
                        if(currentPage === first){firstActive = false; previousActive = false; nextActive = true; lastActive = true;}
                        if(currentPage === last){firstActive = true; previousActive = true; nextActive = false; lastActive = false;}

                    }
                }

                this.timesheetsPaginationObject = {
                    totalRecords: totalRecords,
                    totalPages: totalPages,
                    currentPage: currentPage,
                    first: first,
                    firstActive: firstActive,
                    previous: previous,
                    previousActive: previousActive,
                    next: next,
                    nextActive: nextActive,
                    last: last,
                    lastActive: lastActive,
                };
            },
            // Loop through 2 dates
            loopDate(startDate, endDate) {
                let dates = [];

                let currDate = this.$moment(startDate).startOf('day');
                let lastDate = this.$moment(endDate).startOf('day');
                dates.push(currDate.clone().toDate());
                while(currDate.add(1, 'days').diff(lastDate) < 0) {
                    console.log(currDate.toDate());
                    dates.push(currDate.clone().toDate());
                }
                dates.push(currDate.clone().toDate());
//        alert(dates);
                return dates;
            },
            // Print HTML of Attendance Status
            attendanceBadge(statusID, ignore){
                if(statusID == 1 && ignore != 1){return "<span class='badge badge-success'>Present</span>";}
                // if(statusID == 2 && ignore != 2){return "<span class='badge badge-primary'>Leave</span>";}
                if(statusID == 3 && ignore != 3){return "<span class='badge badge-danger'>Absent</span>";}
                if(statusID == 4 && ignore != 4){return "<span class='badge badge-secondary'>Day-Off</span>";}
                if(statusID == 5 && ignore != 5){return "<span class='badge badge-warning'>Pending</span>";}
            },
            // Alert Test
            attendanceAlert(punches){
                // alert(JSON.stringify(punches));
            },
            // Check Policy Type to determine what drop downs to show during punches associations
            attendancePolicyCheck(policyID) {
                let result = {
                    checkIn : true,
                    checkOut : true,
                    breakStart : true,
                    breakEnd : true,
                    checkIn2 : true,
                    checkOut2 : true,
                    checkIn3 : true,
                    checkOut3 : true,
                    checkIn4 : true,
                    checkOut4 : true,
                }


                if(policyID == 1){ // No Punch
                    result.checkIn = false;
                    result.checkOut = false;
                    result.breakStart = false;
                    result.breakEnd = false;
                    result.checkIn2 = false;
                    result.checkOut2 = false;
                    result.checkIn3 = false;
                    result.checkOut3 = false;
                    result.checkIn4 = false;
                    result.checkOut4 = false;
                }
                if(policyID == 2){ // Single Punch Anytime
                    result.checkIn = true;
                    result.checkOut = false;
                    result.breakStart = false;
                    result.breakEnd = false;
                    result.checkIn2 = false;
                    result.checkOut2 = false;
                    result.checkIn3 = false;
                    result.checkOut3 = false;
                    result.checkIn4 = false;
                    result.checkOut4 = false;
                }
                if(policyID == 3){  // Single Punch Shift Start
                    result.checkIn = true;
                    result.checkOut = false;
                    result.breakStart = false;
                    result.breakEnd = false;
                    result.checkIn2 = false;
                    result.checkOut2 = false;
                    result.checkIn3 = false;
                    result.checkOut3 = false;
                    result.checkIn4 = false;
                    result.checkOut4 = false;
                }
                if(policyID == 4){ // Flexible Day - Flexible Break
                    result.checkIn = true;
                    result.checkOut = true;
                    result.breakStart = true;
                    result.breakEnd = true;
                    result.checkIn2 = true;
                    result.checkOut2 = true;
                    result.checkIn3 = true;
                    result.checkOut3 = true;
                    result.checkIn4 = true;
                    result.checkOut4 = true;
                }
                if(policyID == 5){ // Flexible Day - No Break
                    result.checkIn = true;
                    result.checkOut = true;
                    result.breakStart = false;
                    result.breakEnd = false;
                    result.checkIn2 = true;
                    result.checkOut2 = true;
                    result.checkIn3 = true;
                    result.checkOut3 = true;
                    result.checkIn4 = true;
                    result.checkOut4 = true;
                }
                if(policyID == 6){ // Fixed Day - Fixed Break
                    result.checkIn = true;
                    result.checkOut = true;
                    result.breakStart = true;
                    result.breakEnd = true;
                    result.checkIn2 = true;
                    result.checkOut2 = true;
                    result.checkIn3 = true;
                    result.checkOut3 = true;
                    result.checkIn4 = true;
                    result.checkOut4 = true;
                }
                if(policyID == 7){ // Fixed Day - Flexible Break
                    result.checkIn = true;
                    result.checkOut = true;
                    result.breakStart = true;
                    result.breakEnd = true;
                    result.checkIn2 = true;
                    result.checkOut2 = true;
                    result.checkIn3 = true;
                    result.checkOut3 = true;
                    result.checkIn4 = true;
                    result.checkOut4 = true;
                }
                if(policyID == 8){ // Fixed Day - No Break
                    result.checkIn = true;
                    result.checkOut = true;
                    result.breakStart = false;
                    result.breakEnd = false;
                    result.checkIn2 = true;
                    result.checkOut2 = true;
                    result.checkIn3 = true;
                    result.checkOut3 = true;
                    result.checkIn4 = true;
                    result.checkOut4 = true;
                }
                if(policyID == 9){ // Day Off
                    result.checkIn = true;
                    result.checkOut = true;
                    result.breakStart = true;
                    result.breakEnd = true;
                    result.checkIn2 = true;
                    result.checkOut2 = true;
                    result.checkIn3 = true;
                    result.checkOut3 = true;
                    result.checkIn4 = true;
                    result.checkOut4 = true;
                }

                return result;

            },
            // Sorting Columns
            sortToggle(columnID){
                if(this.sorting.sortBy === columnID){
                    if(this.sorting.sortOrder === 'desc'){this.sorting.sortOrder = 'asc';}
                    else if(this.sorting.sortOrder === 'asc'){this.sorting.sortOrder = 'desc';}
                } else{
                    this.sorting.sortBy = columnID;
                    this.sorting.sortOrder = 'asc';
                }
                this.updateRecordsList();
            },
            sortToggleIcon(columnID){
                let icon = 'sort';
                if(this.sorting.sortBy === columnID){
                    if(this.sorting.sortOrder === 'asc'){icon = 'sort-up';}
                    if(this.sorting.sortOrder === 'desc'){icon = 'sort-down';}
                }
                return icon;
            },



            //////////////////////////////////
            //     Users Attendance List   ///
            //////////////////////////////////

            // This method will be triggered whenever tickets list array needs to fetch in fresh tickets from the server
            updateRecordsList(page){
                this.selectedEmployee = {};
                this.timesheetsListLoading = true;
                if(!page){page = 1;}
                this.sorting.page = page;

                // if(this.searchFilters.isActive){
                this.$store.dispatch('attendance/fetchTimesheetUsers', {filters: this.searchFilters, sorting: this.sorting})
                    .then(response => {
                        this.timesheetsList = this.$store.getters['attendance/getTimesheetUsers'];
                        this.timesheetsPages = this.$store.getters['attendance/getTimesheetPages'];
                        this.timesheetsListLoading = false;
                        this.updateTicketsPaginationObject();

                    })
                    .catch(error => {
                        this.timesheetsListLoading = false;
                    })
                // }
            },

            selectEmployee(employeeObject){
                this.$store.dispatch('user/fetchUser', employeeObject)
                    .then(response => {
                        this.user = this.$store.getters['user/getUser'];
                        this.selectedEmployee = employeeObject;
                        this.shiftToggle = true;
                    })
            },

            closeEmployee() {
                this.selectedEmployee = {};
                this.user = null;
            },

            adjustAttendance(attendance) {
                this.selectedAttendance = attendance;
                this.updateMissingOvertime.attendance_id = attendance.id;
                this.updateMissingOvertime.adjustedMissing = attendance.amc;
                this.updateMissingOvertime.adjustedOvertime = attendance.aoc;
                return this.$refs.updateAttendance.show()
            },

            updateMissingOvertimeForm(){
                this.$store.dispatch('attendance/updateMissingOvertime', this.updateMissingOvertime)
                    .then(response => {
                        this.updateMissingOvertime.onSuccess(response);
                        this.$snotify.success('Missing and Overtime Updated');
                        this.$refs.updateAttendance.hide()
                        this.updateEmployee(this.selectedEmployee.id);
                    })
                    .catch(error => {
                        this.storeTicket.onFail(error);
                        this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);
                    })
            },

            // findWithAttr(array, attr, value) {
            //     for(var i = 0; i < array.length; i += 1) {
            //         if(array[i][attr] === value) {
            //             return i;
            //         }
            //     }
            //     return -1;
            // },

            // Updates the Full Employee Data
            updateEmployee(employeeID){
                if(employeeID > 0 && this.timesheetsList.length > 0){
                    let currentID = employeeID;
                    let currentPosition = this.timesheetsList.map(function(e) { return e.id; }).indexOf(currentID);

                    // alert(this.currentPosition)
                    if(currentPosition > -1){
                        // Update Employee Data
                        this.$store.dispatch('attendance/fetchTimesheetUser', {
                            dateFrom: this.searchFilters.dateFrom,
                            dateTo: this.searchFilters.dateTo,
                            employees: [employeeID],
                        })
                            .then(response => {
                                if(response){
                                    if(response.length > 0){
                                        this.timesheetsList[currentPosition] = response[0];
                                        this.selectedEmployee = response[0];
                                    }
                                }
                            })
                            .catch(error => {
//            alert(JSON.stringify(error))
                            })
                    }
                }
            },

            // Update Leave Form
            updateLeave(attendance, userID, dateDefault){
                this.$store.dispatch('attendance/fetchTimesheetSingleUser', {filters: this.searchFilters, userID: userID})
                    .then(response => {
                        this.selectEmployee(response[0]);
                        this.selectedAttendance = attendance;
                        this.dateSelect.leaveDateFrom = dateDefault;
                        this.leaveForm.dateFrom = dateDefault;
                        this.dateSelect.leaveDateTo = dateDefault;
                        this.leaveForm.dateTo = dateDefault;
                        this.leaveForm.description = null;
                        this.leaveForm.userID = userID;
                    })
                return this.$refs.leaveForm.show()
            },

            updatePunches(attendance, userID, defaultDate){
                if(userID){
                    this.$store.dispatch('attendance/fetchTimesheetSingleUser', {filters: this.searchFilters, userID: userID})
                        .then(response => {
                            this.selectEmployee(response[0]);
                            this.selectedAttendance = attendance;
                            this.punchFilters.attendanceID = attendance.id;
                            this.missingPunchForm.punchDate = defaultDate;
                            this.dateSelect.punchDate = defaultDate;
                            this.missingPunchForm.attendanceID = attendance.id;
                            this.missingPunchForm.userID = userID;
                        })

                } else{
                    this.selectedAttendance = attendance;
                    this.punchFilters.attendanceID = attendance.id;
                    this.missingPunchForm.punchDate = defaultDate;
                    this.dateSelect.punchDate = defaultDate;
                    this.missingPunchForm.attendanceID = attendance.id;
                    this.missingPunchForm.userID = this.selectedEmployee.id;
                }



                if(attendance.pIn){
                    this.multiSelect.checkIn = [attendance.pIn];
                    this.punchFilters.checkIn = attendance.pIn.id;
                } else{this.multiSelect.checkIn = []; this.punchFilters.checkIn = null;}
                if(attendance.pOut){
                    this.multiSelect.checkOut = [attendance.pOut];
                    this.punchFilters.checkOut = attendance.pOut.id;
                } else{this.multiSelect.checkOut = [];  this.punchFilters.checkOut = null;}
                if(attendance.bStart){
                    this.multiSelect.breakStart = [attendance.bStart];
                    this.punchFilters.breakStart = attendance.bStart.id;
                } else{this.multiSelect.breakStart = []; this.punchFilters.breakStart = null;}
                if(attendance.bEnd){
                    this.multiSelect.breakEnd = [attendance.bEnd];
                    this.punchFilters.breakEnd = attendance.bEnd.id;
                } else{this.multiSelect.breakEnd = []; this.punchFilters.breakEnd = null;}
                if(attendance.pIn2){
                    this.multiSelect.checkIn2 = [attendance.pIn2];
                    this.punchFilters.checkIn2 = attendance.pIn2.id;
                } else{this.multiSelect.checkIn2 = []; this.punchFilters.checkIn2 = null;}
                if(attendance.pOut2){
                    this.multiSelect.checkOut2 = [attendance.pOut2];
                    this.punchFilters.checkOut2 = attendance.pOut2.id;
                } else{this.multiSelect.checkOut2 = []; this.punchFilters.checkOut2 = null;}
                if(attendance.pIn3){
                    this.multiSelect.checkIn3 = [attendance.pIn3];
                    this.punchFilters.checkIn3 = attendance.pIn3.id;
                } else{this.multiSelect.checkIn3 = []; this.punchFilters.checkIn3 = null;}
                if(attendance.pOut3){
                    this.multiSelect.checkOut3 = [attendance.pOut3];
                    this.punchFilters.checkOut3 = attendance.pOut3.id;
                } else{this.multiSelect.checkOut3 = []; this.punchFilters.checkOut3 = null;}
                if(attendance.pIn4){
                    this.multiSelect.checkIn4 = [attendance.pIn4];
                    this.punchFilters.checkIn4 = attendance.pIn4.id;
                } else{this.multiSelect.checkIn4 = []; this.punchFilters.checkIn4 = null;}
                if(attendance.pOut4){
                    this.multiSelect.checkOut4 = [attendance.pOut4];
                    this.punchFilters.checkOut4 = attendance.pOut4.id;
                } else{this.multiSelect.checkOut4 = []; this.punchFilters.checkOut4 = null;}


                return this.$refs.updatePunchesOrder.show()
            },


            // Find Missed Punches
            missedPunchesx(employee){
                let userx = null;
                if(this.selectedEmployee){userx = this.selectedEmployee;}
                if(employee){userx = employee;}
                let missedPunches = 0;
                if(userx){
                    if(userx.attendances.length){
                        for (let u of userx.attendances) {
                            if(u.status == 1){missedPunches = missedPunches + u.miss;}
                        }
                    }
                }
                return missedPunches;
            },

            updatePunchesOrder(){
                this.missingPunchForm.attendanceID = this.selectedAttendance.id;
                this.missingPunchForm.userID = this.selectedEmployee.id;

                if(this.selectedAttendance){
                    this.$store.dispatch('attendance/updatePunchesOrder', this.punchFilters)
                        .then(response => {
                            this.punchFilters.onSuccess(response);
                            this.$snotify.success('Punches Association Updated.');
                            this.$refs.updatePunchesOrder.hide()
                            if(this.searchFilters.resultsView == 'attendance'){
                                this.updateEmployee(this.selectedEmployee.id);
                            } else {
                                this.updateRecordsList(this.timesheetsPaginationObject.currentPage);
                            }
                        })
                        .catch(error => {
                            this.punchFilters.onFail(error);
                            this.$snotify.error(error.data.message, 'Invalid Request');
                        })
                }
            },

            addMissingPunch() {
                if(this.selectedAttendance){
                    if(!this.selectedAttendance.punches){this.selectedAttendance.punches = [];}
                    this.missingPunchForm.attendanceID = this.selectedAttendance.id;
                    this.missingPunchForm.userID = this.selectedEmployee.id;

                    this.$store.dispatch('attendance/addMissingPunch', this.missingPunchForm)
                        .then(response => {
                            this.missingPunchForm.onSuccess(response);
                            this.$snotify.success('New Punch Record Saved.');
                            this.selectedAttendance.punches.push(response.data)
                        })
                        .catch(error => {
                            this.missingPunchForm.onFail(error);
                            this.$snotify.error(error.data.message, 'Invalid Request');
                        })
                }
            },

            // Update Just the Timesheets of the Employee
            updateEmployeeTimesheets(){
                if(this.selectedEmployee && this.timesheetsList.length > 0){
                    let currentID = this.selectedEmployee.id;
                    let currentPosition = this.timesheetsList.map(function(e) { return e.id; }).indexOf(currentID);
                    if(currentPosition > -1){
                        // Update Employee Data
                        this.$store.dispatch('attendance/fetchTimesheets', {
                            users_id: this.selectedEmployee.id,
                            dateFrom: this.searchFilters.dateFrom,
                            dateTo: this.searchFilters.dateTo,
                        }) .then(response => {
                            this.selectedEmployee.attendances = response;
                            this.timesheetsList[currentPosition].attendances = response;
                        })
                    }
                }
            },

            loadAttendanceData() {
                // Load Shift Plans
                this.$store.dispatch('shifts/fetchShiftPlans')
                    .then(response => {
                        this.shiftPlans = this.$store.getters['shifts/getShiftPlans'];
                    })
            },
        },

        computed: {
            // Check Date Range if Filter
            dateRange() {
                if(this.searchFilters.dateFrom && this.searchFilters.dateTo)
                {return this.loopDate(this.searchFilters.dateFrom,this.searchFilters.dateTo)}
                else{return [];}
            },
            // React to Page limit changes in sorting
            pageLimit(){
                return this.$store.getters['attendance/getSorting'].limit;
            },
            // New missing time
            newMissingTime(){
                if(this.selectedAttendance && this.updateMissingOvertime)
                {
                    return parseInt(this.selectedAttendance.mc) + parseInt(this.updateMissingOvertime.adjustedMissing)
                }
            },
            // New Overtime time
            newOvertime(){
                if(this.selectedAttendance && this.updateMissingOvertime)
                {
                    return parseInt(this.selectedAttendance.oc) + parseInt(this.updateMissingOvertime.adjustedOvertime)
                }
            },
            // Find Unassigned Users
            unassignedUsers(){
                let unassignedUsers = this.users;
                if(this.selectedTicket){

                    for (let u of this.users) {
                        for (let s of this.selectedTicketUsers) {
                            unassignedUsers = unassignedUsers.filter(function( obj ) {
                                return obj.id !== s.id;
                            });
                        }
                    }
                }
                return unassignedUsers;
            },

            // Find Missed Punches
            missedPunches(){
                let userx = null;
                if(this.selectedEmployee){userx = this.selectedEmployee;}
                let missedPunches = 0;
                if(userx){
                    if(userx.attendances.length){
                        for (let u of userx.attendances) {
                            if(u.status == 1){missedPunches = missedPunches + u.miss;}
                        }
                    }
                }
                return missedPunches;
            },

            // Check In Compute
            unassignedPunches(){
                let unassignedPunches = [];
                let assignedPunches = [];
                if(this.selectedAttendance){

                    // Put the ids of assigned punches to an array
                    if(this.multiSelect.checkIn.length > 0){assignedPunches.push(this.multiSelect.checkIn[0].id);}
                    if(this.multiSelect.checkOut.length > 0){assignedPunches.push(this.multiSelect.checkOut[0].id);}
                    if(this.multiSelect.breakStart.length > 0){assignedPunches.push(this.multiSelect.breakStart[0].id);}
                    if(this.multiSelect.breakEnd.length > 0){assignedPunches.push(this.multiSelect.breakEnd[0].id);}
                    if(this.multiSelect.checkIn2.length > 0){assignedPunches.push(this.multiSelect.checkIn2[0].id);}
                    if(this.multiSelect.checkOut2.length > 0){assignedPunches.push(this.multiSelect.checkOut2[0].id);}
                    if(this.multiSelect.checkIn3.length > 0){assignedPunches.push(this.multiSelect.checkIn3[0].id);}
                    if(this.multiSelect.checkOut3.length > 0){assignedPunches.push(this.multiSelect.checkOut3[0].id);}
                    if(this.multiSelect.checkIn4.length > 0){assignedPunches.push(this.multiSelect.checkIn4[0].id);}
                    if(this.multiSelect.checkOut4.length > 0){assignedPunches.push(this.multiSelect.checkOut4[0].id);}

                    // Push all the unassigned punches in to separate array and return data
                    if(this.selectedAttendance.punches){
                        if(this.selectedAttendance.punches.length > 0){
                            for (let u of this.selectedAttendance.punches) {
                                if(!assignedPunches.includes(u.id)){unassignedPunches.push(u);}
                            }
                        }
                    }

                }
                return unassignedPunches;
            },
        },

        mounted() {
//      this.interval = setInterval(function () {
//        if(this.selectedTicket){
//          this.storeTicketReaders();
//        }
//      }.bind(this), 5000);
        },

        created() {
            this.loadAttendanceData();
            this.updateRecordsList();
            return this.iShowCollapse(this.menuItems)
        },

        watch: {
            $route(to, from) {
                return this.iShowCollapse(this.menuItems)
            },
            // Watch Pagination Changes
            timesheetsPages: function(newValue, oldValue){
                if(newValue){this.updateTicketsPaginationObject();}
            },
            pageLimit(newValue, oldValue){
                if(newValue !== oldValue){this.updateRecordsList();}
            },
        },

        beforeDestroy: function(){
//      clearInterval(this.interval);
        }
    }
</script>

<style scoped>
  .hard_left {
    position:absolute;
    *position: relative; /*ie7*/
    left:0;
    width:50px;
  }
  .next_left {
    position:absolute;
    *position: relative; /*ie7*/
    left:50px;
    width:300px;
  }
  .outer {position:relative}
  .inner {
    overflow-x:scroll;
    overflow-y:visible;
    width:75vw;
    margin-left:350px;
  }
  .hideShiftsClass{
    height:30px;
    overflow: hidden;
  }
  .showShiftsClass{

  }
  /*table {*/
  /*    table-layout: fixed;*/
  /*    width: 100%;*/
  /*    *margin-left: -100px;!*ie7*!*/
  /*}*/
  /*td, th {*/
  /*    vertical-align: top;*/
  /*    border-top: 1px solid #ccc;*/
  /*    padding:10px;*/
  /*    width:100px;*/
  /*}*/
  /*th {*/
  /*    !*  position:absolute;*/
  /*      *position: relative; !*ie7*!*/
  /*    !*  left:0; *!*/
  /*    width:100px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/hr/attendance/attendance.vue